class MemberBreakdownController {
    constructor($http, $window, $timeout) {
        'ngInject';
        this.$http = $http;
        this.$window = $window;
        this.$timeout = $timeout;

        this.data = [];
        this.spinner = true;

        this.httpError = false;
    }

    $onInit() {
        this.$timeout(() => {
            this.$http({
                url: '/api/chapterleader/getchaptersummary',
                method: 'GET'
            }).then((response) => {
                this.data = response.data;
                this.spinner = false;
            }, (response) => {
                this.spinner = false;
                this.httpError = true;
            });
        }, 1000);
    }
}

export default MemberBreakdownController;



// WEBPACK FOOTER //
// ./src/app/angular/member-breakdown/member-breakdown.controller.js